// Datos en convex/lib/geo (los usa también el servidor: campo «Dirección»).
export * from "@/convex/lib/geo/honduras";
